import {
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'information',
    templateUrl: './information.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
/**
 * API to an open modal window.
 */
export class InformationComponent {
  /**
   * Caption for the title.
   */
  @Input() public title: string;
  @Input() public danger: string;
  @Input() public center = true;
  /**
   * component which is to be loaded dynamically.
   */
  public component: any;
  /**
   * Describes if the modal contains Ok Button.
   * The default Ok button will close the modal and emit the callback.
   * Defaults to true.
   */
  public okButton: boolean = true;
  /**
   * Caption for the OK button.
   * Default: Ok
   */
  public okButtonText: string = 'Ok';
  /**
   * if the modalMessage is true it will show the message inside modal body.
   */
  public modalMessage: boolean = true;
  /**
   * Some message/content can be set in message which will be shown in modal body.
   */
  @Input() public message: string;
  /**
   * if the value is true modal footer will be visible or else it will be hidden.
   */
  public modalFooter: boolean = true;
  /**
   * shows modal header if the value is true.
   */
  public modalHeader: boolean = true;
  /**
   * shows load spinner if the value is true.
   */
  public loadSpinner: boolean = false;
  /**
   * shows icon if the value is true.
   */
  public loadedIcon: boolean = false;
  /**
   * shows warning icon if the value is true.
   */
  public warningIcon: boolean = false;
  /**
   * if the value is true modal will be visible or else it will be hidden.
   */
  public isOpen: boolean = false;
  /**
   * Emitted when a ok button was clicked
   * or when close method is called.
   */
  cmpRef: ComponentRef<any>;
  //@ViewChild(OpenDirective) componentDirective: OpenDirective;
  @ViewChild('child', { read: ViewContainerRef, static: true }) target: ViewContainerRef;
  @Output() public confirmOutput: EventEmitter<any> = new EventEmitter();
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();
  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef
  ) {}
  open(component?: any, data?: any) {
    this.isOpen = true;
    this.cdf.detectChanges();
  }
  /**
   *  ok method dispose the component, closes the modal and emits true.
   */
  submit() {
    this.dispose();
    this.confirmOutput.emit(true);
  }
  /**
   *  dispose method dispose the loaded component.
   */
  dispose() {
    this.isOpen = false;
    if (this.component != undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }
}
